import React, { useState, useEffect, useCallback } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { ContentTitle, RightGrid, TypographyLink } from '../ui/styled';
import BackIcon from '../common/Back/BackIcon';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PageHeading from '../common/Heading/PageHeading';
import CommonSearch from '../common/Search/CommonSearch';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import {
  CONTACT_FORM_UPDATE_URL,
  CONTACT_LIST_URL,
  paginationSize,
} from '../../constants';
import { renderCellExpand } from '../common/GridCell/GridCellExpand';
import { getContactList } from './services/contactsApi';
import Button from '@mui/material/Button';
import { getContactReferenceData } from '../../redux/contact/contactForm/contactReferenceSlice';
import {
  getContactForm,
  resetContactForm,
  setNewContactForm,
} from '../../redux/contact/contactForm/contactFormSlice';
import { LeftGrid } from '../Episode/Episode.Styled';
import { resetContactOrganizationAddress } from '../../redux/contact/contactOrganizationAddress/contactOrganizationAddressSlice';

const ContactList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [searchContactList, setSearchContactList] = useState('');
  const [contactList, setContactList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    contactList.pageSize,
    contactList.page,
    contactList.sortModel,
    searchContactList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <CommonSearch
        searchText={searchContactList}
        setSearchText={setSearchContactList}
      />
    );
  };

  const fetchData = async () => {
    setContactList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = commonQueryParams(
      CONTACT_LIST_URL,
      searchContactList,
      contactList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const contacts = await getContactList({
      commonParams,
      authorization,
    });
    setContactList((prveState) => ({
      ...prveState,
      ...contacts,
    }));
  };

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchReferenceData();
    }
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const fetchReferenceData = async () => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getContactReferenceData(authorization));
  };

  const handleSortModelChange = useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    setContactList((prveState) => ({
      ...prveState,
      sortModel: [...sortModel],
    }));
  }, []);

  const updateContactDialog = (params) => {
    const commonParams = `${CONTACT_FORM_UPDATE_URL}/${params.row.cntId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getContactForm({ commonParams, authorization }));
    navigate(`/contacts/details/${params.row.cntId}`);
  };

  const handelNewContactForm = () => {
    dispatch(resetContactForm());
    dispatch(resetContactOrganizationAddress());
    dispatch(setNewContactForm(true));
    navigate(`/contacts/details/0`);
  };

  const columnsData = [
    { field: 'contactKey', headerName: 'Contact Key', flex: 1 },
    {
      field: 'cntId',
      headerName: 'Contact ID',
      renderCell: (params) => {
        return (
          <TypographyLink
            variant='h6'
            onClick={() => updateContactDialog(params)}
          >
            {params.row.cntId}
          </TypographyLink>
        );
      },
      flex: 1,
    },
    {
      field: 'directWorkPhone',
      headerName: 'Direct Work Phone',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'eMail',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'orgKey',
      headerName: 'Org Key',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'parole',
      headerName: 'Parole',
      type: 'boolean',
      flex: 1,
    },
    { field: 'inactive', headerName: 'InActive', type: 'boolean', flex: 1 },
  ];

  return (
    <>
      <ContentTitle container>
        <RightGrid item xs={12} sm={4}>
          <BackIcon />
          <PageHeading title='Contact List' />
        </RightGrid>
        <Grid item xs={12} sm={4}>
          <Box style={{ alignItems: 'center' }}>
            <Typography variant='h4' align='center'>Contacts</Typography>
          </Box>
        </Grid>        
        <LeftGrid item xs={12} sm={4}>
          <Button variant='contained' onClick={() => handelNewContactForm()}>
            New Contact
          </Button>
        </LeftGrid>
      </ContentTitle>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
        <DataGridPro
          //autoHeight
          //getRowHeight={() => 'auto'}
          columns={columnsData}
          rows={contactList.data}
          pageSize={contactList.pageSize}
          page={contactList.page - 1}
          rowCount={contactList.total}
          paginationMode='server'
          sortingMode='server'
          onPageSizeChange={(newPageSize) =>
            setContactList((old) => ({ ...old, pageSize: newPageSize }))
          }
          onPageChange={(newPage) => {
            setContactList((old) => ({ ...old, page: newPage + 1 }));
          }}
          rowsPerPageOptions={paginationSize}
          pagination
          components={{ Toolbar: QuickSearchToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
          onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          loading={contactList.isLoading}
        />
      </div>
    </div>
  </div>      
    </>
  );
};
export default ContactList;
